import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getListArriveLateStart,
  getListArriveLateSuccess,
  getListArriveLateFailed,
} from "../redux/getListArriveLate";
import { getListArriveLateAPI } from "core/http/service/decleareLeave";
import moment from "moment";

function* getListArriveLateWork(action) {
  const { screenCode, ...payload } = action.payload;
  try {
    const res = yield call(getListArriveLateAPI, {
      screenCode,
      ...payload,
    });
    const formattedData = res.data.map((item, index) => ({
      ...item,
      index: index + 1,
      fromDate: moment(item?.fromDate),
      toDate: moment(item?.toDate),
    }));
    yield put({
      type: getListArriveLateSuccess.type,
      payload: formattedData,
    });
  } catch (error: any) {
    yield put({
      type: getListArriveLateFailed.type,
    });
  }
}

function* watchGetListArriveLate() {
  yield takeLatest(getListArriveLateStart.type, getListArriveLateWork);
}

export default function* getListArriveLateSaga() {
  yield all([watchGetListArriveLate()]);
}
